<template>
  <div>
    <label class="toggle-switch">
      <input
        type="checkbox"
        :checked="checked"
        @change="onCheckBoxUpdate"
        :disabled="isDisabled"
      />
      <span class="toggle-switch-slider"></span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    checked: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
  methods: {
    onCheckBoxUpdate(event) {
      this.checked = event.target.checked;
    },
  },
};
</script>

<style scoped>
.toggle-switch {
  display: inline-block;
  position: relative;
  width: 35px;
  height: 19px;
}

.toggle-switch input {
  display: none;
}

.toggle-switch-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  border-radius: 19px;
  transition: background-color 0.2s ease-in-out;
}

.toggle-switch-slider:before {
  position: absolute;
  content: '';
  height: 17px;
  width: 17px;
  left: 1px;
  bottom: 1px;
  background-color: #fff;
  border-radius: 50%;
  transition: transform 0.2s ease-in-out;
}

.toggle-switch input:checked + .toggle-switch-slider {
  background-color: #333343;
}

.toggle-switch input:checked + .toggle-switch-slider:before {
  transform: translateX(16px);
}

.toggle-switch input:not(:checked):disabled + .toggle-switch-slider,
.toggle-switch input:checked:disabled + .toggle-switch-slider {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
